<template>
    <section class="Section">
            <div class="Container">
                <div class="Box">
                    <div class="ShopColumnHolder">
                        <div class="ShopColumnSx">
                            <div class="Bookmark"><span>{{ this.risorse["DettagliOrdine"] }}</span></div>
                            <ShippingInfo/>
                            <BillingAddress/>
                            <UpdateAnagrafica/>
                        </div>
                        <div class="ShopColumnDx">
                            <div class="Bookmark"><span>{{ this.risorse["ConfermaOrdine2"] }}</span></div>
                            <CartSummary/>

                            <div class="WhiteSpace">&nbsp;</div>

                            <CatalogCartContainer 
                                :catalogs="this.$store.getters.getCatalogs"
                            />
                            
                            <BackorderCatalogCartCont
                                :catalogs="this.$store.getters.getCatalogs"
                            />
                            <!-- Fine tabella prodotti -->
                            <div class="WhiteSpace">&nbsp;</div>
                            <CartSummaryBottom/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
</template>

<script>

import ShippingInfo from "@/components/ShippingInfo.vue";
import BillingAddress from "@/components/BillingAddress.vue";
import UpdateAnagrafica from "@/components/UpdateAnagrafica.vue";
import CartSummary from "@/components/CartSummary.vue";
import CartSummaryBottom from "@/components/CartSummaryBottom.vue";
import CatalogCartContainer from "@/components/CatalogCartContainer.vue";
import BackorderCatalogCartCont from "../components/BackorderCatalogCartCont.vue";

import {risorseMixin} from "@/mixin.js";

export default {
    name: "ShoppingCart",
    components:{
        ShippingInfo,
        BillingAddress,
        UpdateAnagrafica,
        CartSummary,
        CartSummaryBottom,
        CatalogCartContainer,
        BackorderCatalogCartCont
    },
    data(){
        return {
            noteOrdine: ""
        }
    },
    mixins:[risorseMixin]
}
</script>